"use client"

import { type LucideIcon } from "lucide-react"
import { Link } from "react-router"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

export function NavProjects({
  projects,
}: {
  projects: {
    name: string
    url: string
    icon: LucideIcon
  }[]
}) {
  const isExternalUrl = (url: string) => url.startsWith("http")

  return (
    <SidebarGroup>
      <SidebarGroupLabel className="text-[11px] leading-4 font-medium text-foreground/80 normal-case border-l-0 pl-0">
        Ferramentas
      </SidebarGroupLabel>
      <SidebarMenu>
        {projects.map((item) => (
          <SidebarMenuItem key={item.name}>
            <SidebarMenuButton asChild tooltip={item.name}>
              {isExternalUrl(item.url) ? (
                <a
                  href={item.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <item.icon />
                  <span>{item.name}</span>
                </a>
              ) : (
                <Link to={item.url}>
                  <item.icon />
                  <span>{item.name}</span>
                </Link>
              )}
            </SidebarMenuButton>
          </SidebarMenuItem>
        ))}
      </SidebarMenu>
    </SidebarGroup>
  )
}
